let _ = t => t,
  _t,
  _t2;
import { getNavigateToTicketRecord } from 'conversations-thread-view/tickets/constants/Events';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RecordLink from 'crm-links/record/RecordLink';
import { Link } from 'foundations-components/transitional/components/Link';
import styledWithTheme from 'foundations-theming/utils';
import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRecordLink = styledWithTheme(RecordLink)(_t || (_t = _`
  ${0}
`), ({
  theme: _theme
}) => {
  const theme = _theme;
  return Object.assign({}, theme.typography['body-200'], {
    color: theme.color['fill-accent-neutral-pressed'],
    maxWidth: 'fit-content'
  });
});
const StyledLink = styledWithTheme(Link)(_t2 || (_t2 = _`
  ${0}
`), ({
  theme: _theme
}) => {
  const theme = _theme;
  return Object.assign({}, theme.typography['body-200'], {
    maxWidth: 'fit-content'
  });
});
const StyledDiv = styled.div.withConfig({
  displayName: "TicketName__StyledDiv",
  componentId: "g6cnxx-0"
})(["@media screen and (max-width:1500px){max-width:400px;}@media screen and (max-width:2000px) and (min-width:1501px){max-width:550px;}@media screen and (min-width:2001px){max-width:1150px;}"]);
const TicketName = ({
  includeEschref,
  ticketId,
  ticketName,
  ticketRecordLink,
  trackEvent,
  useFlex
}) => {
  const subject = ticketName === '' ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "svh-workspace-ui-lib.ticket-header.noTicketName"
  }) : ticketName;
  if (includeEschref) {
    return /*#__PURE__*/_jsx(StyledDiv, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-200",
        "data-test-id": "ticket-header-name-link",
        children: /*#__PURE__*/_jsx(StyledRecordLink, {
          LinkComponentProps: {
            truncate: true,
            truncateStringProps: {
              useFlex
            }
          },
          includeEschref: true,
          objectId: ticketId,
          objectTypeId: "0-5",
          onTrackClick: () => trackEvent(getNavigateToTicketRecord(true)),
          children: subject
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(StyledDiv, {
    children: /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "body-200",
      children: /*#__PURE__*/_jsx(StyledLink, {
        external: true,
        href: ticketRecordLink,
        onClick: () => trackEvent(getNavigateToTicketRecord(true)),
        truncate: true,
        truncateStringProps: {
          useFlex
        },
        "data-test-id": "ticket-header-name-link",
        color: "fill-accent-neutral-pressed",
        children: subject
      })
    })
  });
};
TicketName.displayName = 'TicketName';
export default TicketName;